/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-navigation-back-to-top': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M10 8.125l-6.25 6.25.881.881L10 9.894l5.369 5.362.881-.881L10 8.125zm-7.5-3.75h15v1.25h-15v-1.25z"/>'
  }
})
